import { render, staticRenderFns } from "./ComoFuncionam.vue?vue&type=template&id=b2d58016&"
import script from "./ComoFuncionam.vue?vue&type=script&lang=js&"
export * from "./ComoFuncionam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports